/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './PurchaseMotionsEvaluationService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService#evaluateInApp
 */
export const EVALUATE_IN_APP_QUERY_FIELD_NAME = 'com_hubspot_purchase_motions_rpc_PurchaseMotionsEvaluationService_evaluateInApp';
export const EVALUATE_IN_APP_QUERY = /* #__PURE__ */registerQuery({
  fieldName: EVALUATE_IN_APP_QUERY_FIELD_NAME,
  args: ['productApiNames', 'locations', 'purchaseMotionFilterParameters'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.evaluateInAppRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});